import { observer } from "mobx-react";
import * as React from "react";
import { runInAction } from "mobx";
import './styles.css';
import { dualCostString } from "src/config/Registration";

const EventTicketOptions = observer(({ item }) => {
  const onSelect = () => {
    if (!item.isPurchased) {
      runInAction(() => (item.selected = !item.selected));
    }
  };


  return (
    <div 
      className={`venue-option ticket-option ${item.selected ? "active" : ""} ${item.isPurchased ? "purchased" : ""}`}
      onClick={onSelect}
    >
      <div className="venue-details">
        <div className="venue-name">{item.ticketName}</div>
        <div className="venue-address">
          <span className="price-tag">{dualCostString(item.coinsPrice, item.promoCoinsPrice, item.currency, item.promoEndTime)}</span>
        </div>
      </div>
      {!item.isPurchased && (
        <div className="ticket-checkbox">
          <input 
            type="checkbox" 
            checked={item.selected}
            readOnly
            className="ticket-check"
          />
        </div>
      )}
    </div>
  );
});

export default EventTicketOptions;
